import { computed, Injectable, signal } from '@angular/core';
import { OverlayState } from '../../models/overlay-state.enum';

const OVERLAY_MESSAGE_KEYS: Record<OverlayState, string> = {
  [OverlayState.None]: '',
  [OverlayState.Quote]: 'OVERLAY_MESSAGE_PROCESSING',
  [OverlayState.CustomerStatus]: 'OVERLAY_MESSAGE_PROCESSING',
  [OverlayState.Checkout]: 'OVERLAY_MESSAGE_CONTRACT',
  [OverlayState.Register]: 'OVERLAY_MESSAGE_PROCESSING',
};

@Injectable({ providedIn: 'root' })
export class OverlayService {
  private readonly _state = signal<OverlayState>(OverlayState.None);
  readonly state = this._state.asReadonly();
  readonly messageKey = computed(() => OVERLAY_MESSAGE_KEYS[this._state()]);

  show(state: OverlayState): void {
    this._state.set(state);
  }

  hide(): void {
    this._state.set(OverlayState.None);
  }
}
